import { useEffect, useState } from 'react'
import { Select } from 'antd'
import service from '../../@services'
import { connect } from 'react-redux'
import store from '../../@store'

function StoreSelectAll(props) {
  const {
    style = {},
    onChange = () => {},
    storeListAll,
    mode = '',
    value,
    keyVal = 'storeCode',
    disabled = false,
  } = props
  useEffect(() => {
    if (!storeListAll) {
      service.common.getStoreListAll()
    }
    return () => {}
  }, [storeListAll])
  return (
    <Select
      style={{ width: '140px', ...style, textAlign: 'left' }}
      placeholder="请选择门店"
      mode={mode}
      value={value}
      disabled={disabled}
      onChange={onChange}
    >
      {storeListAll &&
      storeListAll.map((item) => (
          <Select.Option key={item[keyVal]} value={item[keyVal]}>
            {item.storeName}
          </Select.Option>
        ))}
    </Select>
  )
}

export default connect((state) => ({
  storeListAll: state.common.storeListAll,
}))(StoreSelectAll)
